import { useTranslation } from 'react-i18next';
import { IconX } from '@tabler/icons-react';
import { useSettingsStore } from '@stores';

export function EarlyAccessBanner() {
  const { t } = useTranslation(undefined, { keyPrefix: 'EarlyAccess' });
  const { showBanner, setShowBanner } = useSettingsStore();

  const closeBanner = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="bg-primary p-2 text-black">
      <div className="flex items-center justify-between">
        <p className="text font-bold">{t('title')}</p>
        <button onClick={closeBanner}>
          <IconX className="mb-[2px]" size={20} />
        </button>
      </div>
      <p className="text-sm">
        {t('description')}
      </p>
    </div>
  );
}